import api from 'api'
import { z } from 'zod'

export const updateDayforceWebhookRequestSchema = z.object({
  webhookId: z.number().int(),
  fromStatus: z.string(),
  toStatus: z.string(),
})

export type UpdateDayforceWebhookRequest = z.infer<
  typeof updateDayforceWebhookRequestSchema
>

const updateDayforceWebhookResponseSchema = z.object({}).strict()

export const updateDayforceWebhook = async (
  request: UpdateDayforceWebhookRequest
): Promise<void> => {
  const parsed = updateDayforceWebhookRequestSchema.parse(request)

  const response = await api.post('/admin/dayforce/update_webhook', {
    webhookId: parsed.webhookId,
    fromStatus: parsed.fromStatus,
    toStatus: parsed.toStatus,
  })

  updateDayforceWebhookResponseSchema.parse(response.data)
}
